import axios from 'axios'

export const API_URL = `https://security.ncore.kg/api/`

export const $apiJSON = axios.create({
  withCredentials: true,
  baseURL: API_URL,
})

$apiJSON.interceptors.request.use((config) => {
  const t = localStorage.getItem('token')
  if (t) config.headers.Authorization = `Bearer ${t}`
  else delete config.headers.Authorization
  return config
})

export default $apiJSON

// Этот файл настраивает axios клиент для работы с JSON API
// Включает автоматическое добавление токена авторизации к запросам
// и настройку базового URL для API